import React from "react";
import PolicyPage from "@/components/PolicyPage";

export default function Hakkimizda() {
  const sybraxCta = (
    <a
      href="https://sybrax.com"
      target="_blank"
      rel="noopener noreferrer"
      data-testid="hakkimizda-sybrax-cta"
      className="inline-flex items-center gap-1.5 rounded-full border border-slate-300 bg-white px-4 py-2 text-sm font-medium text-[#0F172A] hover:border-[#14A89F] hover:text-[#14A89F] transition-colors"
    >
      Sybrax projelerini incele
      <span aria-hidden="true">↗</span>
    </a>
  );

  return (
    <PolicyPage
      slug="hakkimizda"
      title="Abonelik İptal hakkında"
      intro="Abonelik İptal, abonelik iptali, iade, fatura itirazı ve Tüketici Hakem Heyeti hazırlıklarında kullanıcıların doğru metni ve takip planını oluşturmasına yardımcı olan bir tüketici işlem asistanıdır."
      metaTitle="Abonelik İptal Hakkında | Türkiye Tüketici İşlem Asistanı"
      metaDescription="Abonelik İptal nedir, ne yapar ve ne yapmaz? Türkiye tüketicileri için tasarlanmış işlem asistanının çalışma prensiplerini, güven yaklaşımını ve sınırlarını öğrenin."
      sections={[
        {
          heading: "Abonelik İptal nedir?",
          body: [
            "Abonelik İptal, Türkiye tüketicilerinin sık karşılaştığı iptal, iade ve itiraz süreçlerini basitleştirmek için tasarlanmış bir yardımcı platformdur. Sorununuzu kart tabanlı bir akışta anlar ve size özel hazır başvuru metnini, gerekli belge listesini ve takip planını oluşturur.",
          ],
        },
        {
          heading: "Hangi sorunlarda yardımcı olur?",
          bullets: [
            "İnternet, TV, mobil hat ve dijital platform aboneliklerinin iptali",
            "Fatura, cayma bedeli ve haksız ücret itirazı",
            "E-ticaret iade, değişim ve para iadesi sorunları",
            "Tüketici Hakem Heyeti başvuru dosyası hazırlığı",
          ],
        },
        {
          heading: "Nasıl çalışır?",
          body: [
            "Abonelik İptal Asistanı, seçtiğiniz sorun tipini ve ilgili kurumu analiz eder. Ardından size uygun adımları, kopyalayabileceğiniz Türkçe bir başvuru metnini, gerekli belge listesini ve tarihli bir takip planını sunar. Süreç boyunca sizi kontrolde tutan bir yardımcıdır — sizin yerinize hareket etmez.",
          ],
        },
        {
          heading: "Abonelik İptal ne yapmaz?",
          bullets: [
            "Resmi kurum veya devlet dairesi değildir.",
            "Hukuki danışmanlık ya da avukatlık hizmeti vermez.",
            "Kullanıcı adına resmi başvuru yapmaz; metinleri siz gönderirsiniz.",
            "e-Devlet, banka veya kart bilgilerinize bağlanmaz.",
            "Sizden e-Devlet veya banka şifrenizi asla istemez.",
          ],
        },
        {
          heading: "Güven ve şeffaflık yaklaşımımız",
          body: [
            "Abonelik İptal, tüketiciyle kurum arasındaki iletişimi güçlendirmeyi amaçlar. Bu nedenle her sayfada ne yapıp ne yapmadığımızı açıkça belirtiriz. Hazırlanan metinleri göndermeden önce siz kontrol edersiniz ve süreç boyunca kararı siz verirsiniz.",
          ],
        },
        {
          heading: "Abonelik İptal'i kim geliştirdi?",
          body: [
            "Abonelik İptal, Sybrax tarafından geliştirilen yapay zeka destekli tüketici işlem asistanıdır. Sybrax; hızlı MVP geliştirme, yapay zeka destekli web uygulamaları ve SaaS ürünleri üzerine çalışan bir ürün stüdyosudur.",
          ],
          extra: sybraxCta,
        },
      ]}
    />
  );
}
